module.exports = __webpack_public_path__ + "static/img/sl03.49df5ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sl03.jpg
// module id = 11vg
// module chunks = 0